// 蒸汽控
import Log from '../view/log'
import SteamManagementNav from '../view/SteamManage/SteamManagementNav'
import SteamControllerManagement from '../view/SteamManage/ControllerManagement/ControllerManagement'
import SteamControllerAdd from '../view/SteamManage/ControllerManagement/ControllerAdd'
import SteamControllerCurrent from '../view/SteamManage/ControllerManagement/ControllerCurrent'
import SteamControllerModify from '../view/SteamManage/ControllerManagement/ControllerModify'
import SteamControllerDeviceStatusLog from '../view/SteamManage/ControllerDeviceStatusLog/ControllerDeviceStatusLog'
import SteamAmmeterManagement from '../view/SteamManage/AmmeterManagement/AmmeterManagement'
import SteamAmmeterAdd from '../view/SteamManage/AmmeterManagement/AmmeterAdd'
import SteamAmmeterCurrent from '../view/SteamManage/AmmeterManagement/AmmeterCurrent'
import SteamAmmeterModify from '../view/SteamManage/AmmeterManagement/AmmeterModify'
import SteamDeviceSceneConfig from '../view/SteamManage/DeviceSceneConfig/DeviceSceneConfig'
import SteamConfigCenter from '../view/SteamManage/SteamConfig/SteamConfigCenter'
import SteamConfigModify from '../view/SteamManage/SteamConfig/SteamConfigModify'
import SteamAccountCenter from '../view/SteamManage/SteamAccountConfig/SteamAccountCenter'
import SteamAccountModify from '../view/SteamManage/SteamAccountConfig/SteamAccountModify'
import SteamPayRecord from '../view/SteamManage/SteamPayRecord/SteamPayRecord'
import SteamRentMoney from '../view/SteamManage/SteamRentMoney/SteamRentMoney'
import SteamQuantity from '../view/SteamManage/SteamQuantity/SteamQuantity'
import SteamQuantityPublic from '../view/SteamManage/SteamQuantityPublic/SteamQuantityPublic'
import SteamOverView from '../view/SteamManage/OverView/OverView'
import SteamsettlementRecord from '../view/SteamManage/settlementRecord/settlementRecord'
import SteamConfigSettle from '../view/SteamManage/SteamConfigSettle/SteamConfigSettle'
import SteamMonitoring from '../view/SteamManage/SteamMonitoring/SteamMonitoring'

export default [
  /* 蒸汽控 */
  {
    path: '/steam_controller_management',
    name: 'steam-controller-management',
    components: {
      default: SteamManagementNav,
      a: SteamControllerManagement,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_controller_add',
    name: 'steam-controller-add',
    components: {
      default: SteamManagementNav,
      a: SteamControllerAdd,
    },
  },
  {
    path: '/steam_controller_modify/:id',
    name: 'steam-controller-modify',
    components: {
      default: SteamManagementNav,
      a: SteamControllerModify,
    },
  },
  {
    path: '/steam_controller_device_status_log',
    name: 'steam-controller-device-status-log',
    components: {
      default: SteamManagementNav,
      a: SteamControllerDeviceStatusLog,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_controller_current/:id',
    name: 'steam-controller-current',
    components: {
      default: SteamManagementNav,
      a: SteamControllerCurrent,
    },
  },
  {
    path: '/steam_ammeter_management',
    name: 'steam-ammeter-management',
    components: {
      default: SteamManagementNav,
      a: SteamAmmeterManagement,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_ammeter_add',
    name: 'steam-ammeter-add',
    components: {
      default: SteamManagementNav,
      a: SteamAmmeterAdd,
    },
  },
  {
    path: '/steam_ammeter_current/:id',
    name: 'steam-ammeter-current',
    components: {
      default: SteamManagementNav,
      a: SteamAmmeterCurrent,
    },
  },
  {
    path: '/steam_ammeter_modify/:id',
    name: 'steam-ammeter-modify',
    components: {
      default: SteamManagementNav,
      a: SteamAmmeterModify,
    },
  },
  {
    path: '/steam_device_scene_config',
    name: 'steam-device-scene-config',
    components: {
      default: SteamManagementNav,
      a: SteamDeviceSceneConfig,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_config_center',
    name: 'steam-config-center',
    components: {
      default: SteamManagementNav,
      a: SteamConfigCenter,
    },
  },
  {
    path: '/steam_config_modify',
    name: 'steam-config-modify',
    components: {
      default: SteamManagementNav,
      a: SteamConfigModify,
    },
  },
  {
    path: '/electronic_account_center',
    name: 'steam-account-center',
    components: {
      default: SteamManagementNav,
      a: SteamAccountCenter,
    },
  },
  {
    path: '/steam_config_settle',
    name: 'steam-config-settle',
    components: {
      default: SteamManagementNav,
      a: SteamConfigSettle,
    },
  },
  {
    path: '/steam_account_modify',
    name: 'steam-account-modify',
    components: {
      default: SteamManagementNav,
      a: SteamAccountModify,
    },
  },
  {
    path: '/steam_pay_record',
    name: 'steam-pay-record',
    components: {
      default: SteamManagementNav,
      a: SteamPayRecord,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_settlement_record',
    name: 'steam-settlement-record',
    components: {
      default: SteamManagementNav,
      a: SteamsettlementRecord,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_rent_money',
    name: 'steam-rent-money',
    components: {
      default: SteamManagementNav,
      a: SteamRentMoney,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_quantity',
    name: 'steam-quantity',
    components: {
      default: SteamManagementNav,
      a: SteamQuantity,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_quantity_public',
    name: 'steam-quantity-public',
    components: {
      default: SteamManagementNav,
      a: SteamQuantityPublic,
    },
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/steam_monitoring',
    name: 'steam-monitoring',
    components: {
      default: SteamManagementNav,
      a: SteamMonitoring,
    },
    meta: {
      keepAlive: true,
    },
  },

  {
    path: '/steam/over_view',
    name: 'steam-over-view',
    components: {
      default: SteamManagementNav,
      a: SteamOverView,
    },
  },
  /* 蒸汽控 */

  // 智慧蒸汽操作日志
  {
    path: '/steam_log',
    name: 'steam-log',
    components: {
      default: SteamManagementNav,
      a: Log,
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/SteamManage.js